// src/pages/VisitAsContact.jsx
import React from "react";

const VisitAsContact = () => {
  return (
    <section className="py-8 px-8 md:px-16 font-[Quicksand] text-gray-800 leading-relaxed">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start gap-8">
        {/* Kiri: Peta Lokasi */}
        <div className="w-full md:w-1/2 rounded-2xl shadow-md overflow-hidden">
          <iframe
            title="Furlissimo Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2683.127308084727!2d115.81978731564659!3d-32.02873208121153!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32a1b7349efb1d%3A0x123456789abcdef!2s579A%20Canning%20Highway%2C%20Alfred%20Cove%20WA!5e0!3m2!1sen!2sau!4v1700000000000!5m2!1sen!2sau"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Kanan: Informasi Kontak */}
        <div className="w-full md:w-1/2 space-y-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Our Studio
            </h2>
            <p className="text-base">
              579A Canning Highway, Alfred Cove WA
              <br />
              <span className="text-sm text-gray-500">
                (Rear entrance + parking accessible via Canning Hwy or North
                Lake Road)
              </span>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Contact
            </h2>
            <p className="text-base">
              0455 316 209
              <br />
              <a
                href="mailto:admin@furlissimo.com.au"
                className="text-blue-600 hover:underline font-medium"
              >
                admin@furlissimo.com.au
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Opening Hours
            </h2>
            <p className="text-base">Monday – Friday, 8 am – 5 pm</p>
            <p className="text-sm text-gray-500">
              Saturday – special request only and additional charges apply
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisitAsContact;
